module.exports = __webpack_public_path__ + "static/img/background.ed1ac739.svg";